import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import Aux from "../../../../hoc/Auxilary";
import { Button } from "rsuite";

class CostForm extends Component {

  createTypeFields = typeToName => {
      let fields = [(<option key={"default"} value={"default"} disabled> --Select one-- </option>)];
      for (var type in typeToName) {
          fields.push(<option key={type} value={type}>{type}</option>);
      }
      return fields;
  };

  createNameFields = function(typeToName, type) {
      let fields = [(<option key={"default"} value={"default"} disabled> --Select one-- </option>)];
      typeToName[type].forEach(item => {
          fields.push(<option key={item.id} value={item.id}>{item.name}</option>);
      });
      return fields;
  };

  render() {
    const role = localStorage.getItem("project_role");
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        if (Object.keys(errors).length !== 0) {
            this.props.setFieldTouched("cost_type", true);
            this.props.setFieldTouched("cost_name_type_lkp_id", true);
            this.props.setFieldTouched("cost_value", true);
            this.props.setFieldTouched("cost_data_date", true);

            console.log("cannot submit! Validation failed", errors);
        } else {
          this.props.values.project_id = this.props.currentProjectID;
          if ("cost_type" in values) {
              delete values["cost_type"];
          }
          if ("cost_name_type_lkp_id" in values) {
              values["cost_name_type_lkp_id"] = parseInt(values["cost_name_type_lkp_id"]);
          }
          if ("cost_data_date" in values) {
              values["cost_data_date"] = new Date(values["cost_data_date"]).toJSON().split("T")[0];
          }

          func(values);
          this.props.toggleSmallModalHandler();
        }
      });
    };

    if (this.props.values.cost_name_type_lkp) {
        this.props.values.cost_type = this.props.values.cost_name_type_lkp.cost_type;
    }

    if (!this.props.methods.costNameType) {
      this.props.methods.fetch();
    }

    var typeToName = {};
    this.props.methods.costNameType.forEach(e => {
       if (!(e.cost_type in typeToName)) {
           typeToName[e.cost_type] = []
       }
       typeToName[e.cost_type].push({id: e.cost_name_type_lkp_id, name: e.cost_name});
    });

    let buttonGroup = null;
    if (this.props.values.data_status_id === 1) {
      buttonGroup = (
        <Aux>
          <Button
              color={"blue"}
            type="button"
            onClick={() => {
              validAndHandle(this.props.methods.updateDraft, this.props.values);
            }}
          >
            Save Updates
          </Button>
          <Button
              className={"ml-2"}
              color={"blue"}
            type="button"
            onClick={() => {
              validAndHandle(
                this.props.methods.updateDraftAndSubmit,
                this.props.values
              );
            }}
          >
            Submit for Approval
          </Button>
          <Button type="button" onClick={this.props.handleReset} color={"red"} className={"ml-2"}>
            Reset
          </Button>
        </Aux>
      );
    } else if (this.props.values.data_status_id === 2) {
      if (role === "ROLE_MEMBER" || role === "ROLE_AUDITOR") {
        buttonGroup = (
          <Button
              color={"blue"}
            type="button"
            onClick={() => {
              validAndHandle(this.props.methods.audit, this.props.values);
            }}
          >
            Audit
          </Button>
        );
      }
    } else if (this.props.values.data_status_id === 3) {
      if (role === "ROLE_MEMBER") {
        buttonGroup = (
          <Button
              color={"blue"}
            type="button"
            onClick={() => {
              validAndHandle(this.props.methods.update, this.props.values);
            }}
          >
            Update
          </Button>
        );
      }
    } else {
      buttonGroup = (
        <Aux>
          <Button
              color={"blue"}
            type="button"
            onClick={() => {
              validAndHandle(this.props.methods.draft, this.props.values);
            }}
          >
            Save as Draft
          </Button>
          <Button
              className={"ml-2"}
              color={"blue"}
            type="button"
            onClick={() => {
              validAndHandle(this.props.methods.submit, this.props.values);
            }}
          >
            Submit
          </Button>
          <Button
              color={"red"}
              className={"ml-2"}
              type="button" onClick={this.props.handleReset}>
            Reset
          </Button>
        </Aux>
      );
    }
    var costName = null;
    if (this.props.values && this.props.values.cost_name_type_lkp && this.props.values.cost_name_type_lkp.cost_type) {
      costName = (
          <Aux>
         <label className={"required"} style={this.props.errors.cost_name_type_lkp_id && this.props.touched.cost_name_type_lkp_id && {color: "red"}} htmlFor={"cost_name_type_lkp_id"}>
          Cost Name
        </label>
              <Field
                  style={this.props.errors.cost_name_type_lkp_id && this.props.touched.cost_name_type_lkp_id && {borderColor: "red"}}
                  className="form-control"
                  id={"cost_name_type_lkp_id"}
            name={"cost_name_type_lkp_id"}
            component={"select"}
            value={this.props.values["cost_name_type_lkp_id"] || "default"}
          >
                  {this.createNameFields(typeToName, this.props.values.cost_name_type_lkp.cost_type)}
          </Field>
              {this.props.errors.cost_name_type_lkp_id && this.props.touched.cost_name_type_lkp_id && (
                  <small className={"text-danger"}>{this.props.errors.cost_name_type_lkp_id}</small>
              )}
</Aux>
      );
    } else {
      costName = (
          <Aux>
               <label className={"required"} style={this.props.errors.cost_name_type_lkp_id && this.props.touched.cost_name_type_lkp_id && {color: "red"}} htmlFor={"cost_name_type_lkp_id"}>
                  Cost Name
              </label>
              <Field
                  style={this.props.errors.cost_name_type_lkp_id && this.props.touched.cost_name_type_lkp_id && {borderColor: "red"}}
                  id={"cost_name_type_lkp_id"}
                className="form-control" name={"cost_name_type_lkp_id"} component={"select"} value={"default"}>
            <option value="default" disabled>
              Select Cost Type First
            </option>
          </Field>
              {this.props.errors.cost_name_type_lkp_id && this.props.touched.cost_name_type_lkp_id && (
                  <small className={"text-danger"}>{this.props.errors.cost_name_type_lkp_id}</small>
              )}
          </Aux>
      );
    }

    return (
      <Form>
        <fieldset
          disabled={this.props.disabled}
        >
            <small className={"d-block"}><span style={{color:"red"}}>*</span> required</small>
            <label className={"d-block"} style={this.props.errors.cost_data_date && this.props.touched.cost_data_date && {color: "red"}}>
            Cost Data Date
                <Field
                className="form-control"
              name={"cost_data_date"}
              value={this.props.values.cost_data_date || null}
            />
                {this.props.errors.cost_data_date && this.props.touched.cost_data_date && (
                    <small className={"text-danger"}>{this.props.errors.cost_data_date}</small>
                )}
          </label>



           <label
               className={"required"}
               style={this.props.errors.cost_type && this.props.touched.cost_type && {color: "red"}}
               htmlFor={"cost_name_type_lkp.cost_type"}>
            Cost Type
          </label>

            <Field
                style={this.props.errors.cost_type && this.props.touched.cost_type && {borderColor: "red"}}
                className="form-control"
                id={"cost_name_type_lkp.cost_type"}
              name={"cost_name_type_lkp.cost_type"}
              component={"select"}
              value={(this.props.values.cost_name_type_lkp && this.props.values.cost_name_type_lkp.cost_type) || "default"}
            >
                {this.createTypeFields(typeToName)}
            </Field>
            {this.props.errors.cost_type && this.props.touched.cost_type && (
                <small className={"text-danger"}>{this.props.errors.cost_type}</small>
            )}

            <div>
          {costName}
            </div>
             <label
                 className={"d-block required"}
                 style={this.props.errors.cost_value && this.props.touched.cost_value && {color: "red"}} htmlFor={"cost_value"}>
            Cost Value
            </label>

            <Field
                style={this.props.errors.cost_value && this.props.touched.cost_value && {borderColor: "red"}}
                className="form-control"
                id={"cost_value"}
              name={"cost_value"}
              value={this.props.values.cost_value || ""}
            />
            {this.props.errors.cost_value && this.props.touched.cost_value && (
                <small className={"text-danger"}>{this.props.errors.cost_value}</small>
            )}



            <label className={"d-block"}>
                Cost Description
                <Field
                    component={"textarea"}
                    className="form-control"
                    name={"cost_description"}
                    value={this.props.values.cost_description || ""}
                />
            </label>






        </fieldset>

          {this.props.disabled ? null : (
            {buttonGroup}
            )}
        <Button type="button" onClick={this.props.toggleSmallModalHandler} className="ml-2">
          Cancel
        </Button>
      </Form>
    );
  }
}

var costFormSchema = Yup.object().shape({
    cost_type: Yup.string().required(),
    cost_name_type_lkp_id: Yup.number().required(),
    cost_value: Yup.number().required().typeError("Number required"),
    cost_data_date: Yup.date().nullable().typeError("Date required"),
});

export default withFormik({
  validationSchema: costFormSchema,

  mapPropsToValues({ currentCost }) {
    return {
      ...currentCost
    };
  }
})(CostForm);
